import {
  ValidationMessage,
  ValidationMessageFunction,
} from "@/models/validation-message";
import { z } from "zod";

export const getCreateCustomerSchema = () =>
  z.object({
    name: z.string().nonempty({ message: ValidationMessage.NON_EMPTY }),
    customerNumber: z
      .string()
      .nonempty({ message: ValidationMessage.NON_EMPTY }),
    phone: z.string().max(20, ValidationMessageFunction.MAX(20)).optional(),
    fax: z.string().max(20, ValidationMessageFunction.MAX(20)).optional(),
    homepage: z.string().url({ message: ValidationMessage.URL }).optional(),
    organizationNumber: z
      .string()
      .max(20, ValidationMessageFunction.MAX(20))
      .optional(),
    vat: z.string().max(20, ValidationMessageFunction.MAX(20)).optional(),
    relation: z.string().optional(),
    information: z.string().optional(),
  });
